
const sh = require('shelljs')
const fs = require('fs')
const path = require('path')
const {
	accent, warn, newline,
	config, inquirer,
	ROOT_TO_WEBPACK_PATH
} = require('../common.js')

module.exports = yargs => {

	console.log(accent('ops generalized configuration --\n'))

	_getName()

	// read the package json, clip everything before the @ off,
	// see if the user folder matches any of those

}

function _getName() {

	newline()

	inquirer.prompt({
		type: 'input',
		name: 'name',
		message: `your full name:`
	}).then(({ name }) => {

		if (name) {
			config.set('name', _resolveName(name))
			_getTextEditor()
		} else {
			warn("\tplease provide a valid name")
			_getName()
		}

	})

}

function _getTextEditor() {

	newline()

	inquirer.prompt({
		type: 'list',
		name: 'editor',
		choices: ['sublime', 'atom'],
		message: 'preferred text editor:'
	}).then(({ editor }) => {
		const editorLookup = {
			'atom': "Atom",
			'sublime': "Sublime Text"
		}
		editor = editorLookup[editor]
		config.set('preferred_editor', editor)
		_end()
	})
}

function _end() {
	console.log(accent("\n\tops cli has been configured"))
	console.log("\treconfigure at any time with " +  accent("ops config\n"))
}

function _resolveName(name) {
	return {
		first: name.split(' ')[0],
		last: name.split(' ').pop(),
		full: name
	}
}



// WEBPACK FOOTER //
// ./src/commands/generalconfig.js